import { extendTheme } from "@chakra-ui/react"
import { StyleFunctionProps } from '@chakra-ui/theme-tools'

// import "@fontsource/open-sans";

const theme = extendTheme({
 fonts: {
    heading: "'DINPro', sans-serif",
    body: "'DINPro', sans-serif",
    button: "'DINPro', sans-serif",
    link: "'DINPro Medium', sans-serif"
  },
  colors: {
    blue: {
     "50":"#EBF1F9","100":"#C8D7EF","200":"#A4BEE5","300":"#81A5DA","400":"#5D8BD0","500":"#3A72C5","600":"#2E5B9E","700":"#234476","800":"#172E4F","900":"#0C1727"
    },
    gray: {
      "50": "#FAFAFA",
      "100": "#F0F1F2",
      "200": "#D3D4D8",
      "300": "#B9BCC2",
      "400": "#A1A4AC",
      "500": "#868B95",
      "600": "#6C727E",
      "700": "#585F6C",
      "800": "#2A303C",
      "900": "#353B47"
    },
    cyan: {
      "50":"#E6FAFF","100":"#B9F0FE","200":"#8CE7FD","300":"#5FDDFC","400":"#32D4FB","500":"#05CAFA","600":"#04A2C8","700":"#037996","800":"#025164","900":"#012832"
    },
    teal: {
      "50":"#EDF6F7","100":"#CDE6E9","200":"#ADD6DB","300":"#8DC6CD","400":"#6EB6BF","500":"#4EA6B1","600":"#3E858E","700":"#2F646A","800":"#1F4347","900":"#102123"
    },
    yellow: {
      "50":"#FFF8E5","100":"#FFEAB8","200":"#FFDD8A","300":"#FFCF5C","400":"#FFC22E","500":"#FFB400","600":"#CC9000","700":"#996C00","800":"#664800","900":"#332400"
    },
    orange: {
      "50":"#FFF5E6","100":"#FEE2B9","200":"#FDD08C","300":"#FCBD5F","400":"#FBAA31","500":"#FB9804","600":"#C97903","700":"#965B03","800":"#643D02","900":"#321E01"
    },
    red: {
      "50":"#FCE8EF","100":"#F8BFD2","200":"#F395B5","300":"#EF6C97","400":"#EA437A","500":"#E6195D","600":"#B8144A","700":"#8A0F38","800":"#5C0A25","900":"#2E0513"
    },
    purple: {
      "50":"#EFEBFA","100":"#D3C6F0","200":"#B6A2E7","300":"#9A7DDE","400":"#7D58D4","500":"#6134CB","600":"#4D2AA2","700":"#3A1F7A","800":"#271551","900":"#130A29"
    },
    pink: {
      "50":"#FAEBF5","100":"#F0C6E4","200":"#E7A2D2","300":"#DD7EC0","400":"#D459AF","500":"#CA359D","600":"#A22A7E","700":"#79205E","800":"#51153F","900":"#280B1F"
    }, 
    green: {
        "50":"#F4FAEA","100":"#DFF1C5","200":"#CBE9A0","300":"#B6E07B","400":"#A1D756","500":"#8DCF30","600":"#71A527","700":"#557C1D","800":"#385313","900":"#1C290A"
    },
  },
  components: {
    Link: {
      baseStyle: {
        fontWeight: "500",
      }
    },
    Button: {
      baseStyle: {
        fontWeight: "400"
      },
      variants: {
        solid: (props: StyleFunctionProps) => ({
          bg: "blue.500",
          color: "white",
          _hover: {
             bg: "blue.600",
             border: "none !important",
           }, 
        })
      }
    },
    FormLabel: {
      baseStyle: {
        fontWeight: "600",
      }
    }
  }
}
)

export default theme